"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ControlMessage_1 = __importDefault(require("../ControlMessage"));
const ProxyConnectionResponse_1 = __importDefault(require("./ProxyConnectionResponse"));
const Serializer_1 = require("../../../Serializer");
const StreamID_1 = require("../../../../src/utils/StreamID");
const VERSION = 2;
/* eslint-disable class-methods-use-this */
class ProxyConnectionResponseSerializerV2 extends Serializer_1.Serializer {
    toArray(proxyConnectionResponse) {
        return [
            VERSION,
            ControlMessage_1.default.TYPES.ProxyConnectionResponse,
            proxyConnectionResponse.requestId,
            proxyConnectionResponse.streamId,
            proxyConnectionResponse.streamPartition,
            proxyConnectionResponse.senderId,
            proxyConnectionResponse.direction,
            proxyConnectionResponse.accepted
        ];
    }
    fromArray(arr) {
        const [version, _type, requestId, streamId, streamPartition, senderId, direction, accepted,] = arr;
        return new ProxyConnectionResponse_1.default({
            version,
            requestId,
            streamId: (0, StreamID_1.toStreamID)(streamId),
            streamPartition,
            senderId,
            direction,
            accepted
        });
    }
}
exports.default = ProxyConnectionResponseSerializerV2;
ControlMessage_1.default.registerSerializer(VERSION, ControlMessage_1.default.TYPES.ProxyConnectionResponse, new ProxyConnectionResponseSerializerV2());
//# sourceMappingURL=ProxyConnectionResponseSerializerV2.js.map